import _DialogContent from "@material-ui/core/esm/DialogContent";
import { withStyles } from '@material-ui/core/styles';
const Content = withStyles(() => ({}))(_DialogContent);
export default Content;